import React from 'react';

import { addImage, deleteImage } from '../../../data/serviceBlogs';
import { InputRow } from '../../../helpers/uiComponents/InputRow';
import { tabChange } from '../../../helpers/uiFunctions/uiActions';

class BlogForm extends React.Component {
    
    handleImages(blogId, action, imageId) {
		var image;
		if (action === "DELETE") {
            document.getElementById("image-message").innerText = "Deleting Image...."
			deleteImage(imageId).then(() => {
                this.props.load(blogId);
                document.getElementById("image-message").innerText = "Max Image Size is 5MB"
            })
		}
		if (action === "POST") {
            document.getElementById("image-message").innerText = "Uploading Image...."
			//console.log("save");
			var imgInput = document.getElementById("blog-add-image");
			image = new FormData();
			image.append('image', imgInput.files[0]);

			addImage(image, blogId).then(() => {
				imgInput.value = "";
                document.getElementById("image-message").innerText = "Max Image Size is 5MB"
                this.props.load(blogId);
			});
		}
	}
    assign(clientCode) {
		var currentCodes = this.props.currentBlog.clientCodes;
		var body = this.props.currentBlog;
		if (!currentCodes.includes(clientCode)) {
			currentCodes.push(clientCode);
		} else {
			currentCodes = currentCodes.filter(function(e) { return e !== clientCode });
		}
		body["clientCodes"] = currentCodes;

		this.props.save(body);
	}
    isAssigned(clientCode, list) {
		var checked = false;
		if (list && list.includes(clientCode)) {
			checked = true;
		}
		return checked;
	}

    render() {
        const update = this.props.update;
        const currentBlog = this.props.currentBlog;
        const clients = this.props.clients;
        return(
            <div className="tab blog-1 active">
{/* SETTINGS */}							
                <h2>Settings</h2>
                <InputRow onChange={update} label="Blog Title" type="text" value={currentBlog.name} property="name" />
                <InputRow onChange={update} label="Slug" type="text" value={currentBlog.url} property="url" description="ex: whatever.com/blog/(slug)" />
                <InputRow onChange={update} label="Publish Date" type="date" value={currentBlog.startDate} property="startDate" />
                <InputRow onChange={update} label="End Date" type="date" value={currentBlog.endDate} property="endDate" description="Add an End Date if the article should be removed ta some point.. At the end of a promotion, for example." />
                <InputRow onChange={update} label="Tags" type="text" value={currentBlog.tags} property="tags" description="Comma Separated list like: flooring, hardwood, whatever" />
                <InputRow onChange={update} label="Meta Title" type="text" value={currentBlog.metaTitle} property="metaTitle" />
                <InputRow onChange={update} label="Meta Description" type="text" value={currentBlog.metaDesc} property="metaDesc" />

{/* ARTICLE */}
                <h2>Article</h2>
                <InputRow onChange={update} label="See Documentation section for Basic HTML hints and examples. Articles must be written using basic HTML" property="text" />
                <InputRow onChange={update} type="textarea" rows="25" value={currentBlog.text} property="text" />
                
{/* IMAGES */}
                <h2>Images</h2>
                <div className="input-group">
                    <p>To use images in article, copy the provided HTML below the image and paste whatever needed.</p>
                    <p>Remeber to always give an image an alt tag, it will be the name of the blog by default..</p>
                    <div className="input-row">
                        <label htmlFor="url">Add New Image</label>
                        <div>
                            <input type="file" name="url" id="blog-add-image" className="promo-image" onChange={() => this.handleImages(currentBlog.blogId, "POST")} />
                            <span id={"image-message"}>Max Image Size is 5MB</span>
                        </div>
                    </div>

                    <ul className="images-list">
                        {(currentBlog && currentBlog.images) && (
                            currentBlog.images.map(image =>
                                <li key={image.imageId}>
                                    <div className="delete-img"><i className="fas fa-times icon" onClick={() => this.handleImages(currentBlog.blogId, "DELETE", image.imageId)}></i></div>
                                    <img src={"https://"+image.url} alt={image.imageId} />
                                    <p>&lt;figure&gt;&lt;img src='https://{image.url}' alt='{currentBlog.name}' /&gt;&lt;/figure&gt;</p>
                                </li>
                            )
                        )}
                    </ul>
                </div>
{/* CLIENTS */}
                <h2>Client Assignments</h2>
                <h4>Clients must be <em>Active</em> && <em>Allow Blog Assignment = ON</em></h4>
                <div className="participant-tabs-wrapper">
                    <div id="participant-tabs" className="tabs">
                        <div id={"tab-velocity"}
                            className={"tab participant-velocity"}
                            onClick={() => tabChange("participant", "velocity")} >
                                All
                        </div>
                        {/* New Tabs */}
                        <div id={"tab-velocity-lite"}
                            className={"tab participant-velocity-lite"}
                            onClick={() => tabChange("participant", "velocity-lite")} >
                                Velocity Lite
                        </div>
                        <div id={"tab-velocity-lite"}
                            className={"tab participant-velocity-prime"}
                            onClick={() => tabChange("participant", "velocity-prime")} >
                                Velocity Prime
                        </div>
                        <div id={"tab-velocity-premium"}
                            className={"tab participant-velocity-premium"}
                            onClick={() => tabChange("participant", "velocity-premium")} >
                                Velocity Premium
                        </div>
                        <div id={"tab-velocity-platinum"}
                            className={"tab participant-velocity-platinum"}
                            onClick={() => tabChange("participant", "velocity-platinum")} >
                                Velocity Platinum
                        </div>
                        <div id={"tab-client-ela"}
                            className={"tab participant-client-ela"}
                            onClick={() => tabChange("participant", "client-ela")} >
                                ELA
                        </div>
                        <div id={"tab-client-omnify"}
                            className={"tab participant-client-omnify"}
                            onClick={() => tabChange("participant", "client-omnify")} >
                                Omnify
                        </div>
                        {/* New Tabs */}
                        <div id={"tab-other"}
                            className={"tab participant-other"}
                            onClick={() => tabChange("participant", "other")} >
                                Legacy & Other
                        </div>
                    </div>
                </div>
                <div id="participant-inputs" className="participant-inputs">
                    <div id={"participant-velocity"} className={"tab participant-velocity"}>
                        <ul className="blog-clientList">
                            {(currentBlog && clients) && (
                                clients.map(client => (client.velocity === true && (client.options.allowBlogs === '1' || client.options.allowBlogs === 'true')) &&
                                    ( <React.Fragment key={client.clientCode}>
                                        <li>
                                            <input type="checkbox" onChange={() => this.assign(client.clientCode)} checked={this.isAssigned(client.clientCode, currentBlog.clientCodes)} />
                                            <span>{client.name}</span>
                                            <div>
                                                <p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
                                            </div>
                                        </li>
                                    </React.Fragment> )
                                )
                            )}
                        </ul>
                    </div>
                    {/* New Tabs */}
                    <div id={"participant-velocity-lite"} className={"tab participant-velocity-lite"}>
                        <ul className="blog-clientList">
                            {(currentBlog && clients) && (
                                clients.map(client => (String(client.servicePackage).toLowerCase() === "lite" && (client.options.allowBlogs === '1' || client.options.allowBlogs === 'true')) &&
                                    ( <React.Fragment key={client.clientCode}>
                                        <li>
                                            <input type="checkbox" onChange={() => this.assign(client.clientCode)} checked={this.isAssigned(client.clientCode, currentBlog.clientCodes)} />
                                            <span>{client.name}</span>
                                            <div>
                                                <p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
                                            </div>
                                        </li>
                                    </React.Fragment> )
                                )
                            )}
                        </ul>
                    </div>
                    <div id={"participant-velocity-prime"} className={"tab participant-velocity-prime"}>
                        <ul className="blog-clientList">
                            {(currentBlog && clients) && (
                                clients.map(client => (String(client.servicePackage).toLowerCase() === "prime" && (client.options.allowBlogs === '1' || client.options.allowBlogs === 'true')) &&
                                    ( <React.Fragment key={client.clientCode}>
                                        <li>
                                            <input type="checkbox" onChange={() => this.assign(client.clientCode)} checked={this.isAssigned(client.clientCode, currentBlog.clientCodes)} />
                                            <span>{client.name}</span>
                                            <div>
                                                <p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
                                            </div>
                                        </li>
                                    </React.Fragment> )
                                )
                            )}
                        </ul>
                    </div>
                    <div id={"participant-velocity-premium"} className={"tab participant-velocity-premium"}>
                        <ul className="blog-clientList">
                            {(currentBlog && clients) && (
                                clients.map(client => (String(client.servicePackage).toLowerCase() === "premium" && (client.options.allowBlogs === '1' || client.options.allowBlogs === 'true')) &&
                                    ( <React.Fragment key={client.clientCode}>
                                        <li>
                                            <input type="checkbox" onChange={() => this.assign(client.clientCode)} checked={this.isAssigned(client.clientCode, currentBlog.clientCodes)} />
                                            <span>{client.name}</span>
                                            <div>
                                                <p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
                                            </div>
                                        </li>
                                    </React.Fragment> )
                                )
                            )}
                        </ul>
                    </div>
                    <div id={"participant-velocity-platinum"} className={"tab participant-velocity-platinum"}>
                        <ul className="blog-clientList">
                            {(currentBlog && clients) && (
                                clients.map(client => (String(client.servicePackage).toLowerCase() === "platinum" && (client.options.allowBlogs === '1' || client.options.allowBlogs === 'true')) &&
                                    ( <React.Fragment key={client.clientCode}>
                                        <li>
                                            <input type="checkbox" onChange={() => this.assign(client.clientCode)} checked={this.isAssigned(client.clientCode, currentBlog.clientCodes)} />
                                            <span>{client.name}</span>
                                            <div>
                                                <p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
                                            </div>
                                        </li>
                                    </React.Fragment> )
                                )
                            )}
                        </ul>
                    </div>
                    <div id={"participant-client-ela"} className={"tab participant-client-ela"}>
                        <ul className="blog-clientList">
                            {(currentBlog && clients) && (
                                clients.map(client => (typeof client.ela !== 'undefined' && client.ela === true && (client.options.allowBlogs === '1' || client.options.allowBlogs === 'true')) &&
                                    ( <React.Fragment key={client.clientCode}>
                                        <li>
                                            <input type="checkbox" onChange={() => this.assign(client.clientCode)} checked={this.isAssigned(client.clientCode, currentBlog.clientCodes)} />
                                            <span>{client.name}</span>
                                            <div>
                                                <p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
                                            </div>
                                        </li>
                                    </React.Fragment> )
                                )
                            )}
                        </ul>
                    </div>
                    <div id={"participant-client-omnify"} className={"tab participant-client-omnify"}>
                        <ul className="blog-clientList">
                            {(currentBlog && clients) && (
                                clients.map(client => (typeof client.omnify !== 'undefined' && client.omnify === true && (client.options.allowBlogs === '1' || client.options.allowBlogs === 'true')) &&
                                    ( <React.Fragment key={client.clientCode}>
                                        <li>
                                            <input type="checkbox" onChange={() => this.assign(client.clientCode)} checked={this.isAssigned(client.clientCode, currentBlog.clientCodes)} />
                                            <span>{client.name}</span>
                                            <div>
                                                <p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
                                            </div>
                                        </li>
                                    </React.Fragment> )
                                )
                            )}
                        </ul>
                    </div>
                    {/* New Tabs */}
                    <div id={"participant-other"} className={"tab participant-other"}>
                        <ul className="blog-clientList">
                            {(currentBlog && clients) && (
                                clients.map(client => (client.velocity !== true && (client.options.allowBlogs === '1' || client.options.allowBlogs === 'true')) &&
                                    ( <React.Fragment key={client.clientCode}>
                                        <li>
                                            <input type="checkbox" onChange={() => this.assign(client.clientCode)} checked={this.isAssigned(client.clientCode, currentBlog.clientCodes)} />
                                            <span>{client.name}</span>
                                        </li>
                                    </React.Fragment> )
                                )
                            )}
                        </ul>
                    </div>
                </div>


            </div>
        )
    }
}
export default BlogForm;


// WEBPACK FOOTER //
// ./src/component_blog/components/BlogProfile/BlogForm.js